import React from 'react';
import { connect } from 'react-redux';
// import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import EnhancedTable from './table/EnhancedTable';
import ReturnVoucherDrawer from './drawer/ReturnVoucherDrawer';

import { Title } from '../style';

const ReturnVouchers = () => (
  <div>
    <Grid container spacing={10}>
      <Grid item md={5}>
        <Title>Bon de retour</Title>
      </Grid>
    </Grid>
    <ReturnVoucherDrawer />
    <EnhancedTable />
  </div>
);

export default connect(null, null)(ReturnVouchers);
